/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}
const FamilyCountingBundleGroupAvailabilityTable = props => {

    const colDefs = [];
    const { type } = props;
    if ( type === 'Single' ) {

        colDefs.push(
            {
                field: 'sectionName',
                headerName: 'Section Name',
                sortable: false,
                filter: true,
                width: 210,
                pinned: 'left',
                cellRenderer: params => ( <span>{params.value}</span> )

            }
        );

    }
    colDefs.push(
        {
            field: 'itemDesc',
            headerName: 'Item Availability',
            sortable: false,
            filter: true,
            width: 210,
            pinned: 'left',
            cellRenderer: params => {
                if ( params.value === 'Total Capacity' ||
                params.value === 'Running Avail' ||
                params.value === 'Forecast' ||
                params.value === 'Total Ordered' ||
                params.value === 'Total Available' ||
                params.value === 'Total Avail' ) return ( <span>{params.value}</span> );
                if(params.data.constraintType)
                {
                    return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=${params.data.constraintType}&constraintkey=${params.value}`}><b>{params.value}</b></Link> );
                }
                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=F&constraintkey=${params.value}`}><b>{params.value}</b></Link> );

            }
        }
    );

    props.lastWeeks.forEach( weekObj => {

        const weekEnding = formatGivenDate( weekObj.weekEnding, 'YYYY-MM-DD' );
        const selectedWeekEnding = formatGivenDate( Number( props.selectedLastWeek ), 'YYYY-MM-DD' );

        if ( weekEnding === selectedWeekEnding ||
            new Date( weekEnding ) < new Date( selectedWeekEnding ) ) {

            const dateVal = weekObj.weekEnding;
            let headerName = `${weekObj.monthNumber} \n ${formatGivenDate( Number( dateVal ), 'DDMMMYY' )}`.toUpperCase();
            const dateField = formatGivenDate( Number( dateVal ), 'YYYY-MM-DD' );
            let headerWidth = 105;

            if ( dateField === '2000-01-01' ) {

                headerName = 'Inventory';
                headerWidth = 110;

            }
            if ( dateField === '2000-02-01' ) {

                headerName = 'Rework';
                headerWidth = 110;

            }
            colDefs.push(
                {

                    field: `${Number( dateVal )}`,
                    headerName: `${headerName}`,
                    sortable: true,
                    filter: true,
                    width: headerWidth,

                    cellClassRules: {
                        'atp-family-counting-bundle-group-availability-result-red-cell': 'x < 0'
                    },
                    cellRenderer: params => {

                        if ( params.value > 99999 ) return ( <span>Infinite</span> );
                        return ( <span>{params.value}</span> );

                    }

                }
            );

        }

    } );
    return (

        <section className="atp-search-result-panel family-counting-bundle-group-availability-result-panel ">
            <div className="results-message ">
                {`${props.titleName}`}
            </div>
            <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                <AgGridReactComponent
                    reactNext={true}
                    columnDefs={colDefs}
                    rowData={props.results}
                    onGridReady={onGridReady}
                    headerHeight={56}
                />
            </div>
        </section>
    );

};

FamilyCountingBundleGroupAvailabilityTable.propTypes = {
    results: PropTypes.array.isRequired,
    titleName: PropTypes.string.isRequired,
    selectedLastWeek: PropTypes.string.isRequired,
    lastWeeks: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired
};
export default FamilyCountingBundleGroupAvailabilityTable;
